import { Component } from '@angular/core';
import { Location } from "@angular/common";
import { ActivatedRoute, Router } from "@angular/router";
import { navigateBackOrFallback } from "../shared/screen-shell/screen-navigation.utils";

@Component({
    selector: 'help',
    templateUrl: './help.component.html',
    standalone: false
})
export class HelpComponent {
  public readonly learnTopics = ['play', 'organize', 'findPlayers', 'connect', 'grow', 'network'];
  public learnMode = false;
  public readonly menuItems = ['matches', 'chats', 'howTo', 'stats', 'more', 'locations', 'player', 'feedback'];
  public readonly playerItems = ['membership', 'teamType', 'invites', 'chats', 'details', 'history', 'stats', 'ranking', 'leave', 'update'];
  public readonly managerItems = ['roles', 'become', 'friends', 'teamType', 'seasons', 'schedule', 'recurring', 'nextRecurring', 'chat', 'notify', 'statuses', 'inviteTypes', 'emailInvites', 'remind', 'teams', 'finalEmail', 'score', 'rulebook', 'transfer'];
  public readonly roadmapItems = ['mobile', 'design', 'feedback'];

  constructor(private location: Location, private router: Router, route: ActivatedRoute) {
    this.learnMode = route.snapshot.queryParamMap.get('section') === 'learn';
  }

  public openTopic(topic: string): void {
    this.router.navigate([topic === 'connect' ? '/chat-list' : topic === 'network' ? '/player-detail/false' : '/event-list']);
  }

  public goBack(): void {
    navigateBackOrFallback(this.location, this.router, ["/event-list"]);
  }
}
